<template>
  <v-app>
    <div id="pricing-cards">
      <BaseCard
        v-for="(card, key) in this.getSettings"
        :key="key"
        :title="card.title"
        :description="card.description"
        :type="card.type"
        :price="card.price"
        :storage="card.storage"
        :button-link="card.buttonLink"
        :button-text="card.buttonText"
        :features-title="card.featuresTitle"
        :features="card.features"
      />
    </div>
  </v-app>
</template>
<script>
import BaseCard from '@/components/BaseCard';
import { mapState } from 'vuex';
export default {
  name: 'App',
  computed: {
    ...mapState(['settings']),
    getSettings() {
      return this.settings
    }
  },
  created() {
    this.$store.dispatch('init')
  },
  components: {
    BaseCard
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
#pricing-cards {
  display: none;
  margin: 0 auto;
  width: 100%;
  max-width: 1120px;
  font-family: 'Source Sans Pro', sans-serif;
  @media only screen and (min-width : 768px) {
    display: flex;
  }
}
.v-application--wrap {
  min-height: auto !important;
}
@-moz-document url-prefix() {
  .base-card-features-list li{
    font-size: 14px !important;
  }
}
@media only screen and (min-width : 1020px) {
  @-moz-document url-prefix() {
    .base-card-features-list li{
      font-size: 16px !important;
    }
  }
}
#app {
  display: none;
}
@media only screen and (min-width : 768px) {
  #app {display: block;}
}
@media only screen and (max-width: 767px) {
  .plan-head .floated {
    top: 180px;
  }
}
</style>
